import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import FeaturedArticles from './components/FeaturedArticles';
import CategoryGrid from './components/CategoryGrid';
import LatestArticles from './components/LatestArticles';
import FAQSection from './components/FAQSection';
import NewsletterSection from './components/NewsletterSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '耳骚',
    url: 'https://ersao.fun/',
    description: '耳骚——让你欲罢不能的听觉极致体验。ASMR音频、沉浸式声景、高品质耳机推荐。',
    inLanguage: 'zh-CN',
  };

  const orgSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '耳骚',
    url: 'https://ersao.fun/',
    description: '专注于ASMR听觉体验的中文内容平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '什么是ASMR？为什么叫"耳骚"？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: 'ASMR（Autonomous Sensory Meridian Response）即自发性知觉经络反应，是一种从头皮开始向下蔓延的酥麻愉悦感。"耳骚"是我们对这种极致听觉体验的中文诠释。',
        },
      },
      {
        '@type': 'Question',
        name: '为什么我听ASMR没有感觉？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '大约只有20%-40%的人天生对ASMR敏感。通过系统性的敏感度训练、选择适合自己的触发音类型、使用高品质耳机，大多数人都能逐渐感受到ASMR的愉悦。',
        },
      },
      {
        '@type': 'Question',
        name: '听ASMR需要什么设备？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '一副解析力好的耳机是基础。推荐使用开放式耳机获得宽广声场，或封闭式降噪耳机隔绝环境噪音。',
        },
      },
      {
        '@type': 'Question',
        name: 'ASMR对睡眠有帮助吗？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，ASMR能降低心率、减少压力激素分泌，帮助大脑从活跃状态过渡到放松状态，对改善睡眠有显著效果。',
        },
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedArticles />
        <CategoryGrid />
        <LatestArticles />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
      <ScrollToTop />
    </>
  );
}